import React from "react";
import styles from "./Gallery.module.css";

const WORK_ITEMS = [
  { icon: "🍽️", label: "Kitchen Deep Clean", desc: "Cabinets, counters and grease cut from every surface." },
  { icon: "🛁", label: "Bathroom Renovation", desc: "Fixtures, tiling and plumbing renewed and finished." },
  { icon: "🏢", label: "Office Cleaning", desc: "Desks, floors and washrooms kept fresh and presentable." },
  { icon: "🧱", label: "Post-Renovation Cleanup", desc: "Dust, debris and paint marks fully cleared." },
  { icon: "🖌️", label: "Painting & Touch-Ups", desc: "Interior and exterior walls painted to a clean finish." },
  { icon: "🔌", label: "Plumbing & Electrical", desc: "Repairs and installations done safely and properly." },
];

export default function Gallery() {
  return (
    <section id="gallery" className={styles.section}>
      <div className="container">
        <div className={styles.heading}>
          <p className="jc-eyebrow">Our Work</p>
          <h2 className={styles.title}>A snapshot of the jobs we handle</h2>
          <p className={styles.desc}>
            From a single-room touch-up to a full renovation, here's the kind
            of work our team takes on every week.
          </p>
        </div>

        <div className={styles.grid}>
          {WORK_ITEMS.map((item) => (
            <div className={styles.tile} key={item.label}>
              <span className={styles.tileIcon} aria-hidden="true">
                {item.icon}
              </span>
              <p className={styles.tileLabel}>{item.label}</p>
              <p className={styles.tileDesc}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
